import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import {
    TradeOnboardingCoachmarkConditionalLoader,
    DM_PRO_PLACEMENT,
    DM_STANDARD_PLACEMENT,
} from '../../global/tradeOnboarding/TradeOnboardingCoachmarkConditionalLoader';
import {
    hasSubmittedDesignManagerUpgradeRequest,
    DESIGN_MANAGER_UPGRADED,
} from '../../global/tradeOnboarding/tradeDesignManagerOnboardingRules';

import { TradeDesignManagerModal } from 'dibs-trade-design-manager/exports/TradeDesignManagerModal';
import { DESIGN_MANAGER_UPGRADE_SUBMITTED } from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';
import { DESIGN_MANAGER_PRO } from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';
import DesignManagerLogo from 'dibs-icons/exports/legacy/DesignManagerLogoBlack';

import styles from './PdpRespIconBubbles.scss';

export const PdpRespIconBubbleDesignManagerComponent = props => {
    const [isOpen, setIsOpen] = useState(false);
    const { isDesktop } = useContext(ServerVarsContext);
    const { item, user, skuId } = props;

    const isProAccount = user?.tradeFirmDesignManagerProfile?.accountType === DESIGN_MANAGER_PRO;

    // If user is upgraded to PRO, update the flag to help signal that Pro DM Onboarding Coachmark and
    // On-approval coachmark should not show up at the same time
    if (isProAccount && hasSubmittedDesignManagerUpgradeRequest()) {
        localStorage.setItem(DESIGN_MANAGER_UPGRADE_SUBMITTED, DESIGN_MANAGER_UPGRADED);
    }

    return (
        <div className={styles.designManagerBubbleDiv}>
            <TradeOnboardingCoachmarkConditionalLoader
                type={isProAccount ? DM_PRO_PLACEMENT : DM_STANDARD_PLACEMENT}
                user={user}
                item={item}
            />
            <Link
                className={classnames(styles.bubble, styles.designManager, {
                    [styles.withBorder]: !isDesktop,
                })}
                onClick={() => setIsOpen(true)}
            >
                <DesignManagerLogo className={styles.icon} />
            </Link>
            <TradeDesignManagerModal
                item={item}
                user={user}
                skuId={skuId}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </div>
    );
};

PdpRespIconBubbleDesignManagerComponent.propTypes = {
    relay: PropTypes.object,
    item: PropTypes.object.isRequired,
    skuId: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
};

export const PdpRespIconBubbleDesignManager = createFragmentContainer(
    PdpRespIconBubbleDesignManagerComponent,
    {
        item: graphql`
            fragment PdpRespIconBubbleDesignManager_item on Item {
                ...TradeOnboardingCoachmarkConditionalLoader_item
                ...TradeDesignManagerModal_item
            }
        `,
        user: graphql`
            fragment PdpRespIconBubbleDesignManager_user on User {
                tradeFirmDesignManagerProfile {
                    hasAccount
                    accountType
                }
                ...TradeOnboardingCoachmarkConditionalLoader_user
                ...TradeDesignManagerModal_user
            }
        `,
    }
);
